"use client";

import SocialIcons from "@/src/components/common/pages/social-icons/social-icons";

const ArticleShareButtons = (_: {
  journalAbbr?: string;
  articleId?: number;
  title?: string;
}) => <SocialIcons direction="column" />;

export default ArticleShareButtons;
